// extracted by mini-css-extract-plugin
module.exports = {"container":"productList_container__CGqSk","productList":"productList_productList__o1YeW","viewMore":"productList_viewMore__UxRgd"};